import ReactMounter from 'lib/ReactMounter';
import ClubDealsFormPage from 'pages/ClubDealsFormPage/ClubDealsFormPage';

ReactMounter.registerComponentToMountOnLoad('ClubDealsFormPage', ClubDealsFormPage);
